import { TextField, withStyles } from "@material-ui/core";
import React from "react";
import NumberFormat from "react-number-format";

const styles = theme => ({
  textField: {
    width: "100%",
    marginTop: 0,
    marginBottom: 0
  }
});
class NumberInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  NumberFormatCustom = props => {
    const { inputRef, onChange, ...other } = props;
    const { prefix, suffix, seperator } = this.props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value
            }
          });
        }}
        thousandSeparator={seperator ? seperator : ""}
        prefix={prefix ? prefix : ""}
        suffix={suffix ? suffix : ""}
      />
    );
  };

  handleChange = event => {
    if (this.props.input.onChange && !this.props.readOnly) {
      this.props.input.onChange(event.target.value);
      this.props.input.onBlur(event.target.value);

      if (this.props.changed) {
        this.props.changed(event.target.value);
      }
    }
  };

  shouldComponentUpdate(nextProps) {
    var comparedState = false;
    Object.keys(this.props).map(s => {
      if (this.props[s] !== nextProps[s]) {
        comparedState = true;
      }
      return s;
    });

    return comparedState;
  }

  render() {
    this.props.meta.valid = false;

    let trySubmit = this.props.checkValidation ? true : false;

    const {
      meta: { touched, error }
    } = this.props;

    let lValue = this.props.fixedValue
      ? this.props.fixedValue
      : this.props.input.value
        ? this.props.input.value
        : "";

    return (
      <TextField
        onChange={this.handleChange}
        id={this.props.input.name}
        value={lValue}
        label={this.props.label}
        className={this.props.classes.textField}
        margin="normal"
        error={
          error && error.length > 0 && touched
            ? true
            : error && error.length > 0 && trySubmit
              ? true
              : false
        }
        helperText={(error && touched) || (error && trySubmit) ? error : null}
        name={this.props.prefix}
        InputProps={{
          inputComponent: this.NumberFormatCustom
        }}
      />
    );
  }
}

export default withStyles(styles)(NumberInput);



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/NumberInput.js